export default __webpack_public_path__ + "static/media/sierra.c7207b86.jpeg";